<template>
<div class="chapter">
<div class="inner_page">
<p class="dedt"><a id="page_v"></a>To</p>
<p class="ded">C. S. LEWIS</p>
<p class="ded"><em class="italic">‘Opposition is true friendship’</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Dedication.vue?7ff0c9e3